import axios from 'axios';

const rbskClient = axios.create({
  baseURL: 'nodeapi/rbsk',
});

// Add a request interceptor to include headers for all requests
rbskClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("RBSK_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const username = localStorage.getItem("rbsk_username");
    if (username) {
      config.headers.username = username;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const rbskAPI = {
  login: async (data) => (await rbskClient.post('/rbsk-login', data)).data,
};
